export default "__VITE_ASSET__DCcVSCCw__"